import { GET } from "./apiController";

const MEDIA_BASE = "/api/media";
const CACHE_TTL_MS = 4 * 60 * 1000; // Never cache beyond proxy token expiry.
const mediaUrlCache = new Map();

const cacheKey = (type, mediaId, kind = "") => `${type}:${mediaId}:${kind}`;

const getCachedUrl = (key) => {
  const cached = mediaUrlCache.get(key);
  if (!cached) return null;
  if (cached.expiresAt <= Date.now()) {
    mediaUrlCache.delete(key);
    return null;
  }
  return cached.url;
};

const setCachedUrl = (key, url) => {
  mediaUrlCache.set(key, {
    url,
    expiresAt: Date.now() + CACHE_TTL_MS,
  });
};

/** Avoid mixed-content blocks when backend returns http:// on an https:// page. */
const ensureSecureMediaUrl = (url) => {
  if (!url || typeof url !== "string") return url;
  if (typeof window !== "undefined" && window.location.protocol === "https:" && /^http:\/\//i.test(url)) {
    return url.replace(/^http:\/\//i, "https://");
  }
  return url;
};

export const getSignedMediaUrl = async ({ type, mediaId, kind }) => {
  if (!type || !mediaId) return null;

  try {
    const key = cacheKey(type, mediaId, kind);
    const cached = getCachedUrl(key);
    if (cached) return ensureSecureMediaUrl(cached);

    const query = kind ? `?kind=${encodeURIComponent(kind)}` : "";
    const response = await GET(`${MEDIA_BASE}/${type}/${mediaId}${query}`);
    const proxyUrl = ensureSecureMediaUrl(response?.data?.url || response?.url || null);

    if (proxyUrl) {
      setCachedUrl(key, proxyUrl);
    }

    return proxyUrl;
  } catch {
    // Fail silently — callers show empty preview / fallback, not a toast.
    return null;
  }
};

export const clearSignedMediaUrlCache = () => {
  mediaUrlCache.clear();
};
